export default "__VITE_ASSET__08106mHX__"